onReady(() => {
    const siteNoticeBar = Array.from(document.querySelectorAll('.site-notice-bar'))
    for (const siteNotice of siteNoticeBar) {
        const ctaButton = siteNotice.querySelector('a')
        ctaButton.addEventListener('click', (event) =>
            dataLayer.push({
                event: 'cta-click',
                interactionType: 'click',
                moduleName: 'Site Notice Bar',
                elementType: event.target.nodeName,
                elementContent: ctaButton.textContent.replace("\n", '')
                    .trim(),
                elementClasses: event.target.classList.toString(),
                destinationUrl: event.target.href,
                modulePosition: '0',
                distinctModulePosition: '0',
                moduleTabPosition: '0',
                moduleId: 'site-notice-bar',
                wpLoggedIn: document.body.classList.contains('logged-in')
                    .toString(),
            }),
        )
    }
})
